// Normalização de texto compartilhada pelo portal.

/**
 * Minúsculas sem acento, para busca e ordenação que ignoram acentuação.
 * Ex.: "Ação" → "acao".
 *
 * ⚠️ Decompõe em NFD e descarta os diacríticos combinantes (faixa U+0300–U+036F):
 *    "á" → "a", e o "ç" (que no NFD vira "c" + cedilha combinante) → "c". Mantido
 *    igual às cópias originais que viviam inline no Compras (Catálogo e
 *    Solicitações), extraído para cá na DEM-00072 para não haver três versões.
 */
export const semAcento = (s) => [...String(s || '').normalize('NFD')]
  .filter((ch) => ch.charCodeAt(0) < 0x300 || ch.charCodeAt(0) > 0x36f)
  .join('').toLowerCase();
